import { motion } from "framer-motion";
import { ShoppingBasket } from "lucide-react";
import { useCart } from "@/context/CartContext";

const links = [
  { label: "The Range", href: "#range" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Wholesale", href: "#wholesale" },
];

export const Navbar = () => {
  const { count, setOpen } = useCart();

  return (
    <motion.header
      initial={{ y: -90, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
      className="fixed top-0 inset-x-0 z-50 bg-[#FBF6EC] border-b border-[#2B0B3C]/10"
      data-testid="main-navigation"
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/logo.png" alt="Proppa Foods" className="h-12 w-auto" />
        </a>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-bold tracking-[0.15em] uppercase text-[#2B0B3C]/70 hover:text-[#4A148C] transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <button
          onClick={() => setOpen(true)}
          data-testid="nav-cart-button"
          className="relative flex items-center gap-2 bg-[#2B0B3C] text-white rounded-full px-5 py-2.5 text-sm font-bold uppercase tracking-wide hover:bg-[#4A148C] transition-colors duration-200"
        >
          <ShoppingBasket size={17} strokeWidth={2.5} />
          Basket
          {count > 0 && (
            <span
              data-testid="nav-cart-count"
              className="absolute -top-2 -right-2 bg-[#FF007A] text-white text-[11px] font-bold w-6 h-6 flex items-center justify-center rounded-full"
            >
              {count}
            </span>
          )}
        </button>
      </div>
    </motion.header>
  );
};
